module.exports = __webpack_public_path__ + "static/img/Fcyco.dcb2684.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Fcyco.jpg
// module id = +zn4
// module chunks = 1